export default "__VITE_ASSET__bc2d6795__"